import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';
import { BRAND_GREEN_PRIMARY, DARKER_TEXT } from 'resources/constants/colors';

// ---------------------------------------------------------------------------
// Quick action items
// ---------------------------------------------------------------------------

const ACTION_FIND_THERAPIST = {
    emoji: '🔍',
    label: 'Encontrar\nterapeuta',
    to: '/terapeutas',
    color: '#EDF6E1',
    accent: '#7cb342',
};

const ACTION_MY_THERAPIST = {
    emoji: '🧑‍⚕️',
    label: 'Mi\nterapeuta',
    to: '/home/mi-terapeuta',
    color: '#EDF6E1',
    accent: '#7cb342',
};

const BASE_ACTIONS = [
    {
        emoji: '📅',
        label: 'Mis citas',
        to: '/home/calendario',
        color: '#E8F4FD',
        accent: '#1976d2',
    },
    {
        emoji: '💬',
        label: 'Mensajes',
        to: '/home/mensajes',
        color: '#FFF8E1',
        accent: '#f9a825',
    },
    {
        emoji: '👤',
        label: 'Mi perfil',
        to: '/perfil',
        color: '#F3E8FF',
        accent: '#7e57c2',
    },
];

// ---------------------------------------------------------------------------
// Styled components
// ---------------------------------------------------------------------------

const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
`;

const SectionTitle = styled.p`
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    color: #aaa;
    margin: 0 0 10px;
    padding: 0 2px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
`;

const ActionLink = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
    background: ${({ bg }) => bg};
    border-radius: 16px;
    padding: 14px 8px 12px;
    text-decoration: none;
    animation: ${fadeUp} 0.4s ${({ delay }) => delay}s ease both;
    -webkit-tap-highlight-color: transparent;
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:active {
        transform: scale(0.94);
    }
`;

const ActionEmoji = styled.span`
    font-size: 24px;
    line-height: 1;
`;

const ActionLabel = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: ${({ accent }) => accent};
    text-align: center;
    white-space: pre-line;
    line-height: 1.3;
`;

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

/**
 * QuickActions — grid of 4 quick navigation buttons.
 * Shown on the patient home screen for fast access.
 *
 * @param {boolean} hasTherapist — si el paciente ya tiene terapeuta asignado
 */
const QuickActions = ({ hasTherapist }) => {
    const actions = [hasTherapist ? ACTION_MY_THERAPIST : ACTION_FIND_THERAPIST, ...BASE_ACTIONS];
    return (
    <div>
        <SectionTitle>Acceso rápido</SectionTitle>
        <Grid>
            {actions.map((action, i) => (
                <ActionLink
                    key={action.to}
                    to={action.to}
                    bg={action.color}
                    delay={0.05 * i}
                >
                    <ActionEmoji>{action.emoji}</ActionEmoji>
                    <ActionLabel accent={action.accent}>{action.label}</ActionLabel>
                </ActionLink>
            ))}
        </Grid>
    </div>
    );
};

export default QuickActions;
